
export class Customer {
   customerId: number = 0
   email: string = ''
   name: string = ''
   cell: string = ''
   vreg: string = ''
   totalSales: number = 0
   debtorAcc: string = ''
   VATNumber: string = ''
   dtModified: string = ''
}

export class SelectedCustomer {
   customerId: number;
   email: string;
   name: string;
   cell: string;
   vreg: string;
   VATNumber: string;
}

export class CustomerSubList {
   customerId: number
   vreg: string
}
export class CustomerList {
   customerId: number;
   email: string;
   name: string;
   cell: string;
   data: CustomerSubList[] = [];
   expand: boolean = false;
}

export class customerline{
    Brand: string
    Description: string
    Id: number
    Price: string
    Size: string
    Total: string
    qty: number
    stocktype: string
    msfid: number
 }

 export class customerObj{
    Id: number
    LineItems: customerline[]
    Price: number
    Ref: string
    buyerId:  number
    dtcreated: string
    salequote: string
    sellerId:  number
    status: string
    stateId: number
    stateType: number
    stategroup : number
    vreg: string
 }

 export class customerobj{
    customerId:number
    vreg: string
 }

 export class vehicle{
    vreg: string
    size: string
    Id: string
    make: string
    model: string
    year: string
    odometer: number
    lastSeen: Date
    lastTyreChangeDt: Date
    lastTyreBrandFitted: string
    lastTyreSizeFitted: string
    lastBalancingDt: Date
    lastAlignmentDt: Date
    lastServiceDt: Date
 }

 export class CustomerWhatsApp{
   customer: number;
   sendTo: string;
   vreg: string;
 }

export class SubCustomer{
   customerId: number
   email: string
   name: string
   cell: string
}

export class AddSubCustomer{
   parentCustomerId: number
   subCustomerId: number
}

export class AddCustomerResponse{
   customerId: number
   vreg: string
}

export class LinkedAndSubCustomers{
   linked: Customer[]
   sub: SubCustomer[]
}

export class NewCustomer{
   customerId: number
   name: string
   email: string
   cell: string
   debtorAcc: string
   VATNumber: string
   parentCustomerId: number
}

export class CustomerSubCustomer{
   customerId: number;
   name: string;
   cell: string;
   email: string;
   subcustomers?: CustomerSubCustomer[];  // Nested customers
}

export class CustomerNode {
   name: string;
   customerId: number;
   cell: string;
   email: string;
   disabled?: boolean;
   subcustomers?: CustomerNode[];
 }

 export class FlatCustomerNode {
   expandable: boolean;
   name: string;
   customerId: number;
   cell: string;
   email: string;
   level: number;
   disabled: boolean;
 }

 export class ParentCustomer{
   customerId: number;
   name: string;
   cell: string;
   email: string;
 }

 export class Communities {
   customerGroupId: number;
   groupName: string;
   groupDescription: string;
   canAddMembers: boolean;
   canRemoveMembers: boolean;
   hasCustomerLink: boolean = false;
 }

 export class FlatCommunityNode {
   expandable: boolean;
   name: string;
   groupId: number;
   level: number;
   disabled: boolean;
 }

 export class CommunityNode {
   name: string;
   groupId: number;
   disabled?: boolean;
   community?: CommunityNode[];
 }

 export class CustomerDetails{
   customerId: number;
   groupId: number;
   isActive: boolean;
 }

 //new classes for customer component V2
 export class CustomerParamInfo{
   customerId: number;
   vreg: string;
 }
export class DealLine {
   brand: string;
   brandTier: string;
   description: string;
   id: number;
   price: string;
   size: string;
   total: string;
   qty: number;
   stockTypeId: number;
   stockTypeDescription: string;
   stockTypeImage: string;
}

export class Deal {
   id: number;
   lineItems: DealLine[];
   price: number;
   ref: string;
   buyerId: number;
   dtCreated: string;
   isSale: boolean;
   sellerId: number;
   status: string;
   stateId: number;
   stateType: number;
   stategroup: number;
   vreg: string;
   salesmanName: string;
}
export class CustomerDataV2 {
   vehicles: vehicle[] = [];
   customer: Customer;
   parentCustomer: ParentCustomer | null = null;
   subCustomers: SubCustomer[] = [];
   vreg: string = '';
   communities: Communities[] = [];
   sales: Deal[] = [];
   quotes: Deal[] = [];
   openQuotes: number = 0;
   ltv: number = 0;
   averageSpend: number = 0;
   totalSales: number = 0;
   firstPurchase: Date  | null = null;
   lastPurchase: Date | null = null;
   mostRecentVehicle: string = '';
   mostFrequentTyreBrandsBought: string[] = [];
   mostFrequentTyreBrandTier: string = '';
   mostFrequentSizesBought: string[] = [];
   vehicleFilterTerms: string[] = [];
   statusFilterTerms: string[] = [];
   sizeFilterTerms: string[] = [];
   mostRecentSalesman: string = '';
   salesmanFilterTerms: string[] = [];

   constructor(init?: Partial<CustomerDataV2>) {
      Object.assign(this, init);
   }
}
